import COS from '@tencent/new-cos-js-sdk-v5';
import { getCompanyCosConfig } from '../../../api';
import { API_PREFIX } from '../../../api/config';
import { isSupportSystem } from '../../../config';
import { IAPICommonCosConfigRes } from '../../../model/api-modules';
import { getSupportCookieToken } from '../../admin/lib/ioa-helper';
import { reportPageError } from '../../lib/bk-report';

let cosConfig: IAPICommonCosConfigRes | undefined = undefined;

export const getCosInstance = (url: string) => {
  return new COS({
    // getAuthorization 必选参数
    getAuthorization(options, callback) {
      // 异步获取临时密钥

      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          const { credentials } = data.data;
          if (!data || !credentials) {
            return console.log('error');
          }
          callback({
            TmpSecretId: credentials.tmpSecretId,
            TmpSecretKey: credentials.tmpSecretKey,
            SecurityToken: credentials.sessionToken,
            // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
            StartTime: data.data.startTime, // 时间戳，单位秒，如：1580000000
            ExpiredTime: data.data.expiredTime, // 时间戳，单位秒，如：1580000000
          });
        })
        .catch((error) => {
          console.error('Error:', error);
          reportPageError(error);
        });
    },
  });
};

export const companyCOS = getCosInstance(
  `${location.origin}${API_PREFIX}/cos/sts/company${
    isSupportSystem() ? `?ticket=${getSupportCookieToken()}` : ''
  }`
);

const getCosConfig = async () => {
  if (!cosConfig) {
    cosConfig = await getCompanyCosConfig();
  }
  return cosConfig;
};

export const putCompanyObject = async (fileName: string, file: File) => {
  await getCosConfig();
  if (!fileName || !cosConfig) {
    return '';
  }
  const fileKey = `${cosConfig.uploadDir}${fileName}`;
  await companyCOS.putObject({
    Bucket: cosConfig.bucket,
    Region: cosConfig.region,
    Key: fileKey,
    Body: file,
  });
};

export const getCompanyFileUrl = async (fileName?: string) => {
  await getCosConfig();
  if (!fileName || !cosConfig) {
    return '';
  }
  const fileKey = `${cosConfig.uploadDir}${fileName}`;

  const uploadParams = {
    Bucket: cosConfig.bucket,
    Region: cosConfig.region,
    Key: fileKey,
  };
  const url = await new Promise<string>((resolve, reject) => {
    companyCOS.getObjectUrl(uploadParams, (err, data) => {
      if (err) {
        reject(err);
      }
      resolve(data.Url);
    });
  });
  return url;
};
